// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout__footer[data-v-23b3f64b]{border-top:1px solid #d8dbe0}@media only screen and (max-width: 575px){.layout__footer[data-v-23b3f64b]{text-align:center}}.layout__footer .col__footer--right[data-v-23b3f64b]{text-align:right}@media only screen and (max-width: 575px){.layout__footer .col__footer--right[data-v-23b3f64b]{text-align:center}}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
